export default __webpack_public_path__ + "images/a719638e518ced2e834fe3a52b2c2d81-music_tablet-2.webp";